jQuery(document).ready(function(){ 
  
  function returnUrlParameters() {
    var obj = {};
    obj.referrer = getUrlParameter('referrer');
    obj.kw = getUrlParameter('kw');
    obj.gclid = getUrlParameter('gclid');
    obj.msclkid = getUrlParameter('msclkid');
    obj.creative = getUrlParameter('creative');
    obj.utm_campaign = getUrlParameter('utm_campaign');
    return obj;
  }

  function returnReferrerCampus(Referer) {
    var camp = "";

    if (Referer) {
      if ( Referer.indexOf("google.com") > -1) {
        var camp = "Organic - Google";
      }

      if ( Referer.indexOf("yahoo.com") > -1) {
          var camp = "Organic - Yahoo";
      }

      if ( Referer.indexOf("bing.com") > -1) {
        var camp = "Organic - Bing";
      }

      if ( Referer.indexOf("facebook.com") > -1) {
        var camp = "Organic - Facebook";
      }

      if ( Referer.indexOf("twitter.com") > -1) {
        var camp = "Organic - Twitter";
      }

      if ( Referer.indexOf("instagram.com") > -1) {
        var camp = "Organic - Instagram";
      }

      if ( Referer.indexOf("pinterest.com") > -1) {
        var camp = "Organic - Pinterest";
      }

      if ( Referer.indexOf("youtube.com") > -1) {
        var camp = "Organic - Youtube";
      }

      if ( Referer.indexOf("linkedIn.com") > -1) {
        var camp = "Organic - LinkedIn";
      }
    }

    if (camp) {
      return camp;
    } else {
      return false;
    }
}

  // entry url is where they came into the advantageccs site. 
  // its the current page. If we, in this browsing session, have saved (from home page ppc source for example), use that entry point.
  var EntryUrl = window.location.href;
  var entry = getCookieJQ('advantageccs_EntryUrl');
  if (!entry) {
    var setCookie = jQuery.cookie('advantageccs_EntryUrl', EntryUrl, { expires: 30, path: '/' });
  } else {
    EntryUrl = entry;
  }

  // if the referrer is an advantage property or direct load
  if ( 
    window.document.referrer === "" 
    || window.document.referrer.indexOf("advantageccs") > -1 
    || window.document.referrer.indexOf("advccs2018dev") > -1 
    || window.document.referrer.indexOf("advantageuser.org/Dev") > -1
    || window.document.referrer.indexOf("advwpedev") > -1  
    || window.document.referrer.indexOf("advwpestg") > -1 
    || window.document.referrer.indexOf("advwpeprd") > -1 
  ) {
    var Referer = getCookieJQ('advantageccs_Referer');
  } else {
    // if the referrer is not an advantage property but like google.com
    var Referer = window.document.referrer;
    var setCookie = jQuery.cookie('advantageccs_Referer', Referer, { expires: 30, path: '/' });
  }
  
  var urlParamsObj = returnUrlParameters();
  var kw = getCookieJQ('advantageccs_kw');
  var gclid = getCookieJQ('advantageccs_gclid');
  var msclkid = getCookieJQ('advantageccs_msclkid');
  var creative = getCookieJQ('advantageccs_creative');
  var Ppccampaign_Last = getCookieJQ('advantageccs_Ppccampaign_Last');
  var ppcCampaign = getCookieJQ('advantageccs_ppcCampaign');
  var EntryUrl_unescaped = "";
  var Referer_unescaped = "";
  var kw_unescaped = "";
  var Ppccampaign_Last_unescaped = "";
  var ppcCampaign_unescaped = "";

  // set ppc info from ppc url if we are on a ppc link
  if (window.location.search != "") {
    if (window.location.search.startsWith('s=')) {
        // search page
    } else {
      // ppc referrer page
      var urlParamsObj = returnUrlParameters();
      
      if (urlParamsObj.kw) {
        var setCookie = jQuery.cookie('advantageccs_kw', urlParamsObj.kw, { expires: 30, path: '/' });
        kw = urlParamsObj.kw;
      }

      if (urlParamsObj.gclid) {
        var setCookie = jQuery.cookie('advantageccs_gclid', urlParamsObj.gclid, { expires: 30, path: '/' });
        gclid = urlParamsObj.gclid;
      }

      if (urlParamsObj.msclkid) {
        var setCookie = jQuery.cookie('advantageccs_msclkid', urlParamsObj.msclkid, { expires: 30, path: '/' });
        msclkid = urlParamsObj.msclkid;
      }

      if (urlParamsObj.creative) {
        var setCookie = jQuery.cookie('advantageccs_creative', urlParamsObj.creative, { expires: 30, path: '/' });
        creative = urlParamsObj.creative;
      }

      if (urlParamsObj.utm_campaign) {
        var setCookie = jQuery.cookie('advantageccs_Ppccampaign_Last', urlParamsObj.utm_campaign, { expires: 30, path: '/' });
        Ppccampaign_Last = urlParamsObj.utm_campaign;
      }

      if (!ppcCampaign) {
        var setCookie = jQuery.cookie('advantageccs_ppcCampaign', urlParamsObj.utm_campaign, { expires: 30, path: '/' });
        ppcCampaign = urlParamsObj.utm_campaign;
      }

    }
  }
  
  
    if (EntryUrl) {
      var EntryUrl_unescaped = EntryUrl.replace(/%3F/g, "?");
      EntryUrl_unescaped = EntryUrl_unescaped.replace(/%3D/g, "=");
      EntryUrl_unescaped = EntryUrl_unescaped.replace(/%26/g, "&");
      EntryUrl_unescaped = EntryUrl_unescaped.replace(/%22/g, "+");
      EntryUrl_unescaped = EntryUrl_unescaped.replace(/%2520/g, "+");
      EntryUrl_unescaped = EntryUrl_unescaped.replace(/%20/g, "+");
      EntryUrl_unescaped = EntryUrl_unescaped.replace(/ /g, "+");
      EntryUrl_unescaped = EntryUrl_unescaped.replace(/%20/g, "+");
      EntryUrl_unescaped = EntryUrl_unescaped.replace(/%3A/g, ":");
      EntryUrl_unescaped = EntryUrl_unescaped.replace(/%2F/g, "/");  
    }
    
    if (Referer) {
      var Referer_unescaped = Referer.replace(/%3F/g, "?");
      Referer_unescaped = Referer_unescaped.replace(/%3D/g, "=");
      Referer_unescaped = Referer_unescaped.replace(/%26/g, "&");
      Referer_unescaped = Referer_unescaped.replace(/%2520/g, "+");
      Referer_unescaped = Referer_unescaped.replace(/%20/g, "+");
      Referer_unescaped = Referer_unescaped.replace(/ /g, "+");
      Referer_unescaped = Referer_unescaped.replace(/%3A/g, ":");
      Referer_unescaped = Referer_unescaped.replace(/%2F/g, "/");
    }

    if (kw) {
      var kw_unescaped = kw.replace(/%3F/g, "?");
      kw_unescaped = kw_unescaped.replace(/%3D/g, "=");
      kw_unescaped = kw_unescaped.replace(/%26/g, "&");
      kw_unescaped = kw_unescaped.replace(/%22/g, " ");
      kw_unescaped = kw_unescaped.replace(/%2520/g, " ");
      kw_unescaped = kw_unescaped.replace(/%20/g, " ");
    }

    if (Ppccampaign_Last) {
      var Ppccampaign_Last_unescaped = Ppccampaign_Last.replace(/%3F/g, "?");
      Ppccampaign_Last_unescaped = Ppccampaign_Last_unescaped.replace(/%3D/g, "=");
      Ppccampaign_Last_unescaped = Ppccampaign_Last_unescaped.replace(/%26/g, "-");
      Ppccampaign_Last_unescaped = Ppccampaign_Last_unescaped.replace(/&/g, "-");
      Ppccampaign_Last_unescaped = Ppccampaign_Last_unescaped.replace(/%2520/g, "");
      Ppccampaign_Last_unescaped = Ppccampaign_Last_unescaped.replace(/%20/g, "");
      Ppccampaign_Last_unescaped = Ppccampaign_Last_unescaped.replace(/ /g, "");
      Ppccampaign_Last_unescaped = Ppccampaign_Last_unescaped.replace(/%3A/g, ":");
      Ppccampaign_Last_unescaped = Ppccampaign_Last_unescaped.replace(/%2F/g, "/");

      if ( Ppccampaign_Last.indexOf("Organic") > -1) {
        if (Referer) {
          var camp = returnReferrerCampus(Referer);
          if (camp) {
            Ppccampaign_Last = camp;
            Ppccampaign_Last_unescaped = camp;
            var setCookie = jQuery.cookie('advantageccs_Ppccampaign_Last', camp, { expires: 30, path: '/' });  
          }
        }
      }

    } else {
        if (Referer) {
          var camp = returnReferrerCampus(Referer);
          if (camp) {
            Ppccampaign_Last = camp;
            Ppccampaign_Last_unescaped = camp;
            var setCookie = jQuery.cookie('advantageccs_Ppccampaign_Last', camp, { expires: 30, path: '/' });  
          }
      }
    }


    if (ppcCampaign) {
      var ppcCampaign_unescaped = ppcCampaign.replace(/%3F/g, "?");
      ppcCampaign_unescaped = ppcCampaign_unescaped.replace(/%3D/g, "=");
      ppcCampaign_unescaped = ppcCampaign_unescaped.replace(/%26/g, "-");
      ppcCampaign_unescaped = ppcCampaign_unescaped.replace(/&/g, "-");
      ppcCampaign_unescaped = ppcCampaign_unescaped.replace(/%2520/g, "");
      ppcCampaign_unescaped = ppcCampaign_unescaped.replace(/%20/g, "");
      ppcCampaign_unescaped = ppcCampaign_unescaped.replace(/ /g, "");
      ppcCampaign_unescaped = ppcCampaign_unescaped.replace(/%3A/g, ":");
      ppcCampaign_unescaped = ppcCampaign_unescaped.replace(/%2F/g, "/");
    } else {
        if (Referer) {
          var camp = returnReferrerCampus(Referer);
          if (camp) {
            ppcCampaign = camp;
            ppcCampaign_unescaped = camp;
            var setCookie = jQuery.cookie('advantageccs_ppcCampaign', camp, { expires: 30, path: '/' });  
          }
      }
    }
    
    const occAnchorListQuery = [
      "a[href*='https://www.advantageuser.org/devocc/api/0.1/get-started.php']",
      "a[href*='https://www.advantageuser.org/DevOCC/api/0.1/get-started.php']",
      "a[href*='https://www.advantageuser.org/occ/api/0.1/get-started.php']",
      "a[href*='https://www.advantageuser.org/OCC/api/0.1/get-started.php']",
      "a[href*='https://www.advantageuser.org/devocc/api/0.1/get-started-debt.php']",
      "a[href*='https://www.advantageuser.org/DevOCC/api/0.1/get-started-debt.php']",
      "a[href*='https://www.advantageuser.org/occ/api/0.1/get-started-debt.php']",
      "a[href*='https://www.advantageuser.org/OCC/api/0.1/get-started-debt.php']",
    ].join(', ');

    var anchorList = jQuery(occAnchorListQuery).addClass('counselingLink');
    if(anchorList.length > 0) {
        var $referpass = jQuery("<form style='display:none' action='' name='referpass' method='post'></form>");
        $referpass
          .append("<input type='hidden' name='acr' value='1' />")
          .append("<input type='hidden' name='EntryUrl' value='" + EntryUrl_unescaped + "' />")
          .append("<input type='hidden' name='Referer' value='" + Referer_unescaped + "' />")
          .append("<input type='hidden' name='ppcCampaign' value='" + ppcCampaign_unescaped + "' />")
          .append("<input type='hidden' name='Ppccampaign_Last' value='" + Ppccampaign_Last_unescaped + "' />")
          .append("<input type='hidden' name='kw' value='" + kw_unescaped + "' />")
          .append("<input type='hidden' name='creative' value='" + creative + "' />")
          .append("<input type='hidden' name='gclid' value='" + gclid + "' />")
          .append("<input type='hidden' name='msclkid' value='" + msclkid + "' />");

          const passThroughParams = [
            'FName',
            'LName',
            'Zip',
            'Email',
          ]
          const params = new URLSearchParams(window.location.search);
          passThroughParams.forEach( param => {
            if ( params.has(param) ) {
              $referpass.append("<input type='hidden' name='"+param+"' value='" + params.get(param) + "' />");
            }
          });
        jQuery('body').append('rp', $referpass[0]);
        jQuery('a.counselingLink')
        .bind('click', function(e){
          e.preventDefault();
          var url = jQuery(this).attr('href');

          $referpass.attr('action',url);
          $referpass.submit();
          return false;
        });
      
      // Setup is done, re-enable links
      var lnks = [
        "a[href*='https://www.advantageuser.org/devocc/api/0.1/get-started.php']",
        "a[href*='https://www.advantageuser.org/occ/api/0.1/get-started.php']",
        "a[href*='https://www.advantageuser.org/DevOCC/api/0.1/get-started.php']",
        "a[href*='https://www.advantageuser.org/OCC/api/0.1/get-started.php']",
        "a[href*='https://www.advantageuser.org/devocc/api/0.1/get-started-debt.php']",
        "a[href*='https://www.advantageuser.org/DevOCC/api/0.1/get-started-debt.php']",
        "a[href*='https://www.advantageuser.org/occ/api/0.1/get-started-debt.php']",
        "a[href*='https://www.advantageuser.org/OCC/api/0.1/get-started-debt.php']",
      ];
      lnks.map(function(val){
        enableLinks(document.querySelectorAll(val));
      });
    }

    ppcCampaign = ppcCampaign.replace(/%26/g, "-");
    ppcCampaign = ppcCampaign.replace(/&/g, "-");
    ppcCampaign = ppcCampaign.replace(/%2520/g, "");
    ppcCampaign = ppcCampaign.replace(/%20/g, "");
    ppcCampaign = ppcCampaign.replace(/ /g, "");

    Ppccampaign_Last = Ppccampaign_Last.replace(/%26/g, "-");
    Ppccampaign_Last = Ppccampaign_Last.replace(/&/g, "-");
    Ppccampaign_Last = Ppccampaign_Last.replace(/%2520/g, "");
    Ppccampaign_Last = Ppccampaign_Last.replace(/%20/g, "");
    Ppccampaign_Last = Ppccampaign_Last.replace(/ /g, "");

    // for the advisor and bank counseling system out links to pass referrer info
    var anchorList2 = jQuery("a[href*='/counseling/index.php'], a[href*='/counseling/bankruptcy_begin.cfm'], a[href*='/DevBank/index.php'], a[href*='/DevAdvisor/index.php'], a[href*='/BudgetAdvisor/index.php'], a[href*='login.php'], a[href*='onlinebudgetadvisor.com']");
    if(anchorList2.length > 0) {
      anchorList2.each(function() {
          var href = jQuery(this).attr('href');
          href = href + "?external=true";

          if (ppcCampaign) {
            href = href + "&ppcCampaign=" + encodeURI(ppcCampaign);
          }

          if (Ppccampaign_Last) {
            href = href + "&Ppccampaign_Last=" + encodeURI(Ppccampaign_Last);
          }

          if (EntryUrl) {
            href = href + "&EntryUrl=" + encodeURI(EntryUrl);
          }

          if (Referer) {
            href = href + "&Referer=" + encodeURI(Referer);
          }

          if (kw) {
            href = href + "&kw=" + encodeURI(kw);
          }

          if (creative) {
            href = href + "&creative=" + encodeURI(creative);
          }

          if (gclid) {
            href = href + "&gclid=" + encodeURI(gclid);
          }

          if (msclkid) {
            href = href + "&msclkid=" + encodeURI(msclkid);
          }

          jQuery(this).attr('href',href);
      });

      // Setup is done, re-enable links
      // these were disabled in init/setupDependantLinks.js
      var lnks = [
        "a[href*='/counseling/index.php']",
        "a[href*='/counseling/bankruptcy_begin.cfm']",
        "a[href*='/DevBank/index.php']",
        "a[href*='/DevAdvisor/index.php']",
        "a[href*='/BudgetAdvisor/index.php']",
        "a[href*='login.php']",
        "a[href*='onlinebudgetadvisor.com']"
      ];
      lnks.map(function(val){ 
        enableLinks(document.querySelectorAll(val));
      });
    }

    var contactForm = jQuery('#contact-form');
    if(contactForm) {
      contactForm
      .append("<input type='hidden' name='acr' value='1' />")
      .append("<input type='hidden' name='EntryUrl' value='" + EntryUrl_unescaped + "' />")
      .append("<input type='hidden' name='Referer' value='" + Referer_unescaped + "' />")
      .append("<input type='hidden' name='ppcCampaign' value='" + ppcCampaign_unescaped + "' />")
      .append("<input type='hidden' name='Ppccampaign_Last' value='" + Ppccampaign_Last_unescaped + "' />")
      .append("<input type='hidden' name='kw' value='" + kw_unescaped + "' />")
      .append("<input type='hidden' name='creative' value='" + creative + "' />")
      .append("<input type='hidden' name='gclid' value='" + gclid + "' />")
      .append("<input type='hidden' name='msclkid' value='" + msclkid + "' />");
    }

    var af_lead_form = jQuery('#lead-form');
    if(af_lead_form) {
      af_lead_form
      .append("<input type='hidden' name='acr' value='1' />")
      .append("<input type='hidden' name='EntryUrl' value='" + EntryUrl_unescaped + "' />")
      .append("<input type='hidden' name='Referer' value='" + Referer_unescaped + "' />")
      .append("<input type='hidden' name='ppcCampaign' value='" + ppcCampaign_unescaped + "' />")
      .append("<input type='hidden' name='Ppccampaign_Last' value='" + Ppccampaign_Last_unescaped + "' />")
      .append("<input type='hidden' name='kw' value='" + kw_unescaped + "' />")
      .append("<input type='hidden' name='creative' value='" + creative + "' />")
      .append("<input type='hidden' name='gclid' value='" + gclid + "' />")
      .append("<input type='hidden' name='msclkid' value='" + msclkid + "' />");
    }

});